import { Box, Typography } from "@mui/material";

type Props = {
  description: string;
};

export const Description = ({ description }: Props) => (
  <Box textAlign="center">
    <Typography
      variant="body2"
      color="text.secondary"
      fontSize="0.813rem"
      lineHeight={1.4}
      fontWeight={300}
    >
      {description}
    </Typography>
  </Box>
);
